import { render, staticRenderFns } from "./CenterOrUserDrawer.vue?vue&type=template&id=ca420164&scoped=true&"
import script from "./CenterOrUserDrawer.vue?vue&type=script&lang=ts&"
export * from "./CenterOrUserDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CenterOrUserDrawer.vue?vue&type=style&index=0&id=ca420164&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca420164",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
